<template>
  <div v-if="isValid">
    <v-main>
      <v-container>
        <v-form ref="form" lazy-validation>
          <v-flex xs12 text-xs-center>
            <v-img :src="require('../assets/hp-logo.gif')" class="my-3" contain height="200"></v-img>
          </v-flex>

          <v-flex xs12 text-xs-center>
            <h1
              class="display-2 font-weight-bold mb-3"
              align="center"
            >{{ companyName }} - ({{ event }}) {{ year }}</h1>
          </v-flex>
          <br />

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">1. What was the name of your trainer?</h2>
            <v-radio-group v-model="answers.trainer" :rules="[rules.required]" row>
              <v-radio
                v-for="participant in participants"
                :key="participant"
                :label="participant"
                :value="participant"
              ></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">2. Overall how would you rate the workshop?</h2>

            <v-radio-group v-model="answers.rateWorkshop" :rules="[rules.required]" row>
              <v-radio label="Excellent" value="excellent"></v-radio>
              <v-radio label="Very Good" value="verygood"></v-radio>
              <v-radio label="Good" value="good"></v-radio>
              <v-radio label="Average" value="average"></v-radio>
              <v-radio label="Poor" value="poor"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >3. How would you rate the content of the workshop?</h2>

            <v-radio-group v-model="answers.workshopContent" :rules="[rules.required]" row>
              <v-radio label="Excellent" value="excellent"></v-radio>
              <v-radio label="Very Good" value="verygood"></v-radio>
              <v-radio label="Good" value="good"></v-radio>
              <v-radio label="Average" value="average"></v-radio>
              <v-radio label="Poor" value="poor"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >4. Did the workshop increase your understanding of the topic?</h2>

            <v-radio-group v-model="answers.increaseUnderstanding" :rules="[rules.required]" column>
              <v-radio label="Yes" value="yes"></v-radio>
              <v-radio label="No" value="no"></v-radio>
              <v-radio label="I Don't Know" value="dontknow"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >5. What principles or techniques did you find most useful from the session?</h2>

            <v-textarea
              v-model="answers.usefulPrinciplesTechniques"
              name="input-7-1"
              filled
              label="Please type here..."
            ></v-textarea>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >6. Were there any elements that you think should be changed or included?</h2>

            <v-textarea
              v-model="answers.elementsChangeInclude"
              name="input-7-1"
              filled
              label="Please type here..."
            ></v-textarea>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >7. Based on your experience how likely are you to recommend or attend similar sessions in the future?</h2>

            <v-radio-group v-model="answers.recommend" :rules="[rules.required]" column>
              <v-radio label="Extremely Likely" value="extremelylikely"></v-radio>
              <v-radio label="Likely" value="likely"></v-radio>
              <v-radio label="Unsure" value="unsure"></v-radio>
              <v-radio label="No" value="no"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >8. Please let us know if you have any additional feedback or suggestions to help improve our service moving forward</h2>

            <v-textarea
              v-model="answers.feedback"
              name="input-7-1"
              filled
              label="Please type here..."
            ></v-textarea>
          </v-flex>

          <v-btn block color="#b0cf3d" class="float-right mb-10" @click="save">Submit</v-btn>
        </v-form>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "./../graphql/queries";
import * as mutations from "./../graphql/mutations";
export default {
  async created() {
    var that = this;
    API.graphql(
      graphqlOperation(queries.getSurveyWorkshop, {
        id: this.$route.params.id
      })
    )
      .then(result => {
        this.isValid = true;
        const survey = result.data.getSurveyWorkshop;
        this.companyName = survey.company;
        this.participants = JSON.parse(survey.participants);
        this.event = survey.name;
      })
      .catch(err => {
        that.isValid = false;
      });
  },
  data: () => ({
    answers: [],
    isValid: true,
    companyName: null,
    participants: null,
    event: null,
    count: 0,
    year: new Date().getFullYear(),
    rules: {
      required: v => !!v || "This field is required."
    }
  }),
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        const workshop = {
          trainer: this.answers.trainer,
          rateWorkshop: this.answers.rateWorkshop,
          workshopContent: this.answers.workshopContent,
          increaseUnderstanding: this.answers.increaseUnderstanding,
          usefulPrinciplesTechniques: this.answers.usefulPrinciplesTechniques,
          elementsChangeInclude: this.answers.elementsChangeInclude,
          recommend: this.answers.recommend,
          surveyWorkshopFeedbackSurveyWorkshopId: this.$route.params.id,
          feedback: this.answers.feedback
        };

        API.graphql(
          graphqlOperation(mutations.createSurveyWorkshopFeedback, {
            input: workshop
          })
        )
          .then(res => {
            this.$router.push({ path: "/thankyou" });
          })
          .catch(err => (this.error = err.message));
      }
    }
  }
};
</script>

<style>
.v-radio {
  margin-right: 50px;
}
</style>